import { render, staticRenderFns } from "./Distribuidores.vue?vue&type=template&id=54e5aec9&"
import script from "./Distribuidores.vue?vue&type=script&lang=js&"
export * from "./Distribuidores.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports